var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm rounded-pill",class:_vm.btnClass,on:{"click":function($event){$event.preventDefault();return _vm.onClickBtn($event)}}},[_c('span',{staticClass:"va-sub"},[_vm._v(_vm._s(_vm.btnText))])])}
var staticRenderFns = []

export { render, staticRenderFns }